module.exports = "https://web-assets.ifttt.com/packs/media/ifttt_next/img-footer-web-desktop-pro-a986772b.svg";